import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@verantos-dev/app-state-base';
import {
  type ActiveIndexDateItemLegacy,
  DerivedEventTypeLegacy,
  IndexDateTypeLegacy,
  SimpleEventType,
  SimpleEventTypeLegacy,
  SubjectVariableTypeLegacy,
} from '@verantos-dev/types-cohorts';

export const selectCohortBuilderState = (state: RootState) => state.cohortBuilder;

// Selects the active cohort builder item
export const selectActiveCohortBuilderItem = createSelector(
  selectCohortBuilderState,
  (cohortBuilderState) => {
    return cohortBuilderState?.activeCohortBuilderItem;
  }
);

// Selects the active cohort builder item id
export const selectActiveCohortBuilderItemId = createSelector(
  selectActiveCohortBuilderItem,
  (activeCohortBuilderItem) => {
    return activeCohortBuilderItem?.id;
  }
);

export const selectActiveCohortBuilderItemName = createSelector(
  selectActiveCohortBuilderItem,
  (activeCohortBuilderItem) => {
    return activeCohortBuilderItem?.name;
  }
);

export const selectActiveCohortBuilderItemType = createSelector(
  selectActiveCohortBuilderItem,
  (activeCohortBuilderItem) => {
    return activeCohortBuilderItem?.type;
  }
);

export const selectActiveCohortBuilderItemAnyOrder = createSelector(
  selectActiveCohortBuilderItem,
  (activeCohortBuilderItem) => {
    return activeCohortBuilderItem?.anyOrder;
  }
);

export const selectActiveCohortBuilderItemSubjectVariableType = createSelector(
  selectActiveCohortBuilderItem,
  (activeCohortBuilderItem) => {
    return activeCohortBuilderItem?.type as SubjectVariableTypeLegacy | undefined;
  }
);

export const selectActiveCohortBuilderItemIndexDateType = createSelector(
  selectActiveCohortBuilderItem,
  (activeCohortBuilderItem) => {
    return activeCohortBuilderItem?.type as IndexDateTypeLegacy | undefined;
  }
);

export const selectActiveCohortBuilderItemSimpleEventType = createSelector(
  selectActiveCohortBuilderItem,
  (activeCohortBuilderItem) => {
    return activeCohortBuilderItem?.type as SimpleEventTypeLegacy | SimpleEventType | undefined;
  }
);

export const selectActiveCohortBuilderItemDerivedEventType = createSelector(
  selectActiveCohortBuilderItem,
  (activeCohortBuilderItem) => {
    return activeCohortBuilderItem?.type as DerivedEventTypeLegacy | undefined;
  }
);

export const selectActiveCohortBuilderItemConceptFilters = createSelector(
  selectActiveCohortBuilderItem,
  (activeCohortBuilderItem) => {
    return activeCohortBuilderItem?.conceptFilters;
  }
);

export const selectActiveCohortBuilderItemNumericFilters = createSelector(
  selectActiveCohortBuilderItem,
  (activeCohortBuilderItem) => {
    return activeCohortBuilderItem?.numericFilters;
  }
);

export const selectActiveCohortBuilderItemRelatedEntityFilters = createSelector(
  selectActiveCohortBuilderItem,
  (activeCohortBuilderItem) => {
    return activeCohortBuilderItem?.relatedEntityFilters;
  }
);

export const selectActiveCohortBuilderItemUniquenessFilters = createSelector(
  selectActiveCohortBuilderItem,
  (activeCohortBuilderItem) => {
    return activeCohortBuilderItem?.uniquenessFilters;
  }
);

export const selectActiveCohortBuilderItemTemporalConstraints = createSelector(
  selectActiveCohortBuilderItem,
  (activeCohortBuilderItem) => {
    return activeCohortBuilderItem?.temporalConstraints;
  }
);

export const selectActiveCohortBuilderItemEventFilters = createSelector(
  selectActiveCohortBuilderItem,
  (activeCohortBuilderItem) => {
    return activeCohortBuilderItem?.eventFilters;
  }
);

export const selectActiveCohortBuilderItemCountFilter = createSelector(
  selectActiveCohortBuilderItem,
  (activeCohortBuilderItem) => {
    return activeCohortBuilderItem?.countFilter;
  }
);

export const selectActiveCohortBuilderItemTimeWindow = createSelector(
  selectActiveCohortBuilderItem,
  (activeCohortBuilderItem) => {
    return activeCohortBuilderItem?.timeWindow;
  }
);

export const selectActiveCohortBuilderItemInputFieldConfigMap = createSelector(
  selectActiveCohortBuilderItem,
  (activeCohortBuilderItem) => {
    return activeCohortBuilderItem?.inputFieldConfigMap;
  }
);

export const selectActiveCohortBuilderItemIndexDateValue = createSelector(
  selectActiveCohortBuilderItem,
  (activeCohortBuilderItem) => {
    return (activeCohortBuilderItem as ActiveIndexDateItemLegacy).indexDateValue;
  }
);

export const selectActiveCohortBuilderItemIndexDateEvent = createSelector(
  selectActiveCohortBuilderItem,
  (activeCohortBuilderItem) => {
    return (activeCohortBuilderItem as ActiveIndexDateItemLegacy).indexDateEvent;
  }
);

export const selectActiveCohortBuilderItemIndexDateRange = createSelector(
  selectActiveCohortBuilderItem,
  (activeCohortBuilderItem) => {
    return (activeCohortBuilderItem as ActiveIndexDateItemLegacy)?.indexDateRangeValue;
  }
);
